import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Image from 'next/image';
import type { CmsApiOptions } from '@/services/cms/CmsApiOptions';
export type ErrorPageProps = CmsApiOptions & {
  code?: string;
  title?: string;
  message?: ReactNode;
  children?: ReactNode;
  error?: Error;
};
export function ErrorPage(t0) {
  const $ = _c(23);
  const {
    code,
    title,
    message,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      py: 4,
      alignItems: "center",
      justifyContent: "space-between"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Box sx={{
      display: "flex",
      alignItems: "center",
      flexShrink: 0
    }}><Image src="/images/getaway-logo.svg" width={207} height={56} alt="Getaway Motor Sales" unoptimized={true} /></Box>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "100%",
      maxWidth: 600
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      textAlign: "center"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== code) {
    t5 = code ? <Typography variant="body1" fontWeight={600} color="primary">{code}</Typography> : null;
    $[4] = code;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== title) {
    t6 = title ? <Typography variant="h1" sx={{
      mt: 4,
      fontSize: {
        xs: "2.5rem",
        sm: "4rem"
      },
      fontWeight: 600,
      letterSpacing: "-0.02em",
      color: "text.primary",
      textWrap: "balance"
    }}>{title}</Typography> : null;
    $[6] = title;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== message) {
    t7 = message ? <Typography variant="body1" sx={{
      mt: 6,
      fontSize: {
        xs: "1.125rem",
        sm: "1.25rem"
      },
      fontWeight: 500,
      color: "text.secondary",
      textWrap: "pretty",
      lineHeight: {
        sm: 2
      }
    }}>{message}</Typography> : null;
    $[8] = message;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      mt: 10,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 2
    };
    t9 = <Button variant="contained" color="primary" href="/">Go back home</Button>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t8 = $[10];
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      fontSize: "0.875rem"
    };
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Box sx={t8}>{t9}<Link href="#" variant="body2" fontWeight={600} color="text.primary" underline="hover" sx={t10}>Contact support{" "}<Box component="span" aria-hidden="true">→</Box></Link></Box>;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t12 = <Box sx={t3}><Box sx={t4}>{t5}{t6}{t7}{t11}</Box></Box>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      display: "flex",
      alignItems: "center",
      flexShrink: 0
    };
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Box sx={t13}>© {new Date().getFullYear()} Getaway Motor Sales</Box>;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== children || $[21] !== t12) {
    t15 = <Box component="main" sx={t1}>{t2}{t12}{children}{t14}</Box>;
    $[20] = children;
    $[21] = t12;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  return t15;
}